import Vue from 'vue'

// input 自动获取焦点
Vue.directive('myfocus', {
  bind: function (el) {
    el.focus()
  },
  updated: function (el) {
    el.focus()
  },
  inserted: function (el) {
    el.focus()
  },
})


// WEBPACK FOOTER //
// ./src/directive.js